import React, { useEffect, useRef, useState } from "react"
import Navbar from "../components/Navbar"
import Footer from "../components/Footer"

import heroImg from "../assets/abuthr.png"
import esimImg from "../assets/board-device.jpg"
import KeyFeatures from "../components/KeyFeatures"
import technologyImg from "../assets/abt2.png"
import benefitImg from "../assets/tracksmart.jpg"
import contactImg from "../assets/contact-image.jpg"
import howItWorksImg from "../assets/howitwork.jpg";
import camersImg from "../assets/camera.jpg"
import enhanceImg from "../assets/enhancedsafety.avif"
import operationalImg from "../assets/Operational Efficiency.jpeg"
import peaceImg from "../assets/peace of mind.jpg"
// import { LocationOnOutlined, CreditCard, NotificationsNoneOutlined, ChevronLeft, ChevronRight } from "@mui/icons-material";
import { RefreshCw } from 'lucide-react'
import mapimage from '../assets/mapimage.png'
import slf from '../assets/slf.png'
import HowItWorksSection from "../components/home/HowItWorksSection"
import SchoolBusTracking from "../components/SchoolBusTracking"


const containerClass = "mx-auto w-full max-w-[1160px] px-4 sm:px-6 lg:px-8"

const features = [
  {
    title: "Real-Time GPS Tracking",
    desc: "Monitor bus location in real-time with precise GPS technology. Get accurate ETA and route information.",
  },
  {
    title: "RFID Attendance System",
    desc: "Automated attendance tracking with RFID technology. Know exactly when students board and exit the bus.",
  },
  {
    title: "Instant Notifications",
    desc: "Parents receive real-time alerts about pickup, drop-off, and delays, keeping them informed at all times.",
  },
]

const howItWorksSteps = [
  {
    number: "01",
    title: "Consultation & Analysis",
    text: "We begin with a thorough assessment of your fleet operations, identifying pain points, inefficiencies, and specific requirements. Our experts work closely with your team to understand your business objectives and develop a tailored solution plan.",
  },
  {
    number: "02",
    title: "Hardware Installation",
    text: "Our technicians install certified tracking, fuel monitoring, and safety devices with clean wiring, secure mounting, and proper calibration for reliable field performance.",
  },
  {
    number: "03",
    title: "Software Setup & Integration",
    text: "We configure dashboards, alerts, reports, routes, users, and integrations so your team can monitor vehicles, fuel, safety, and operations from one platform.",
  },
  {
    number: "04",
    title: "Training & Deployment",
    text: "Your team receives practical training, live testing, and handover support so the system can be used confidently from day one without operational disruption.",
  },
]

const stepIndicatorPositions = ["top-5", "top-[58px]", "top-[96px]", "top-[134px]"]

const technologyItems = [
  "Live tank inventory with level, density, and temperature tracking",
  "Live tank inventory with level, density, and temperature tracking",
  "Live tank inventory with level, density, and temperature tracking",
  "Live tank inventory with level, density, and temperature tracking",
]

const benefits = [
  {
    title: "Enhanced Safety",
    text: "Real-time tracking and monitoring ensure student security throughout the journey.",
    image: enhanceImg,
  },
  {
    title: "Operational Efficiency",
    text: "Optimize routes and driver monitoring to reduce costs and improve punctuality.",
    image: operationalImg,
  },
  {
    title: "Peace of Mind",
    text: "Parents can track their child's journey in real-time, reducing anxiety and uncertainty.",
    image: peaceImg,
  },
]
const feature = [
  "Real-time Dashboard", "Driver and Routes Management",
  "Live School Bus Tracking", "Route Playback",
  "AIS140 Compliance", "Speed Monitoring",
  "Geofencing for School Zones", "Accident Call Alert",
  "Driver Behaviour Monitoring", "RFID and Panic Buttons"
];

const featureitem = [
  "Harsh Braking", "Driver Score Card",
  "Harsh Acceleration", "Driving Limit",
  "Over-Speed Monitoring", "Sharp Turn Monitoring",
  "Driver Rating & Scoreboard"
];


const Administration = [
  "All in one Dashboard", "Fee Management",
  "Route Playback", "Holiday and Leave Management",
  "School Management", "Notice and Syllabus Management",
  "Attendance Management","Time-Table Management",
  "Event Management","Examination Records"
];
  const items = [
    "Live tank inventory with level, density, and temperature tracking",
    "Live tank inventory with level, density, and temperature tracking",
    "Live tank inventory with level, density, and temperature tracking",
    "Live tank inventory with level, density, and temperature tracking"
  ];
const scrollToWhyChoose = () => {
  document
    .getElementById("why-choose-solution")
    ?.scrollIntoView({ behavior: "smooth" });
};

function Reveal({ children, className = "", direction = "up", delay = "" }) {
  const ref = useRef(null)
  const [visible, setVisible] = useState(false)

  useEffect(() => {
    const current = ref.current
    if (!current) return undefined

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true)
          observer.unobserve(current)
        }
      },
      { threshold: 0.18, rootMargin: "0px 0px -40px 0px" }
    )

    observer.observe(current)

    return () => observer.disconnect()
  }, [])

  const hiddenPosition = {
    up: "translate-y-10",
    left: "-translate-x-10",
    right: "translate-x-10",
    zoom: "scale-95",
  }

  return (
    <div
      ref={ref}
      className={`transition-all duration-700 ease-out ${delay} ${visible
        ? "translate-x-0 translate-y-0 scale-100 opacity-100"
        : `${hiddenPosition[direction] || hiddenPosition.up} opacity-0`
        } ${className}`}
    >
      {children}
    </div>
  )
}

function SignalIcon() {
  return (
    <svg viewBox="0 0 40 40" className="h-10 w-10" fill="none" aria-hidden="true">
      <circle cx="20" cy="20" r="4" stroke="currentColor" strokeWidth="4" />
      <path d="M12 12C7.6 16.4 7.6 23.6 12 28" stroke="currentColor" strokeWidth="4" strokeLinecap="round" />
      <path d="M28 12C32.4 16.4 32.4 23.6 28 28" stroke="currentColor" strokeWidth="4" strokeLinecap="round" />
      <path d="M7 7C0 14 0 26 7 33" stroke="currentColor" strokeWidth="3" strokeLinecap="round" />
      <path d="M33 7C40 14 40 26 33 33" stroke="currentColor" strokeWidth="3" strokeLinecap="round" />
    </svg>
  )
}

function RefreshIcon() {
  return (
    <svg viewBox="0 0 32 32" className="h-7 w-7" fill="none" aria-hidden="true">
      <path d="M25 9.5A10.5 10.5 0 0 0 7.7 6.4L5 9.2" stroke="currentColor" strokeWidth="2.8" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M5 4.8v4.4h4.4" stroke="currentColor" strokeWidth="2.8" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M7 22.5a10.5 10.5 0 0 0 17.3 3.1L27 22.8" stroke="currentColor" strokeWidth="2.8" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M27 27.2v-4.4h-4.4" stroke="currentColor" strokeWidth="2.8" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  )
}

function HeroSection() {
  return (
    <section className="relative mx-auto w-full max-w-[calc(100%-8px)] overflow-hidden rounded-b-[34px] bg-black sm:max-w-[calc(100%-24px)] sm:rounded-b-[46px] lg:max-w-[calc(100%-32px)] lg:rounded-b-[58px]">
      <Navbar />

      <div className="relative min-h-[500px] overflow-hidden sm:min-h-[560px] lg:min-h-[620px]">
        <img
          src={heroImg}
          alt="School bus monitoring solution"
          className="absolute inset-0 h-full w-full object-cover"
        />
        <div className="absolute inset-0 bg-black/70" />

        <div className="relative z-10 flex min-h-[500px] items-center justify-center px-4 pt-24 text-center text-white sm:min-h-[560px] lg:min-h-[620px]">
          <Reveal>
            <div className="max-w-[900px]">
              <h1 className="relative inline-block text-[30px] font-bold leading-tight sm:text-[48px] lg:text-[58px]">
                School Bus Monitoring Solution
                <span className="absolute -bottom-4 left-1/2 h-[3px] w-[72%] -translate-x-1/2 rounded-full bg-[#ef7d00]" />
              </h1>

              <p className="mx-auto mt-9 max-w-[690px] text-[14px] leading-relaxed text-white/75 sm:text-[15px]">
                Ensuring student safety with real-time tracking and advanced monitoring technology.
              </p>

              <div className="mt-8 flex flex-col justify-center gap-4 sm:flex-row sm:flex-wrap sm:gap-5">
                <button
                  onClick={scrollToWhyChoose}
                  className="w-full rounded-md bg-[#ef7d00] px-8 py-3.5 text-[15px] font-medium text-white transition duration-300 hover:-translate-y-1 hover:bg-[#d96f00] sm:w-auto sm:px-10"
                >
                  Explore Features
                </button>

                <a
                  href="/contact"
                  className="w-full rounded-md border border-white px-8 py-3.5 text-[15px] font-medium text-white transition duration-300 hover:-translate-y-1 hover:bg-white hover:text-black sm:w-auto sm:px-10"
                >
                  Request demo
                </a>
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  )
}

function Platform() {
  return (
    <section className="mx-auto max-w-[1400px] px-4 py-12 sm:px-6 sm:py-16">
      <div className="grid gap-10 items-center md:grid-cols-2 lg:gap-12">

        {/* Left Side: Text and Features */}
        <div>
          <h2 className="mb-5 text-3xl font-bold leading-tight text-gray-900 sm:mb-6 sm:text-4xl">
            Complete School Transportation Management Platform
          </h2>
          <p className="mb-8 text-base text-gray-600 sm:mb-10 sm:text-lg">
            Monitor school buses in real time, manage routes, track driver behavior,
            ensure student safety, and streamline transportation operations through one centralized dashboard.
          </p>

          <div className="grid grid-cols-1 gap-x-4 gap-y-5 sm:grid-cols-2 sm:gap-y-6">
            {feature.map((feature, i) => (
              <div key={i} className="flex items-start gap-3">
                <div className="shrink-0 rounded-full bg-orange-100 p-2 text-orange-500">
                  <RefreshCw size={18} />
                </div>
                <span className="text-sm font-semibold leading-snug text-gray-700 sm:text-base">{feature}</span>
              </div>
            ))}
          </div>
        </div>

        {/* Right Side: Dashboard Image */}
        <div className="relative">
          <div className="bg-white p-2 rounded-xl shadow-2xl border border-gray-100">
            <img
              src={mapimage}
              alt="School Management Dashboard"
              className="rounded-lg w-full h-auto"
            />
          </div>
        </div>

      </div>
    </section>
  )
}

function Administrations() {
  return (
   <section className="mx-auto max-w-[1400px] px-4 py-12 sm:px-6 sm:py-16">
  <div className="mb-10 text-center sm:mb-16">
    <h2 className="mb-4 text-3xl font-bold text-gray-900 sm:text-4xl">Smart School Administration Platform</h2>
    <p className="mx-auto max-w-3xl text-base text-gray-600 sm:text-lg">
      Streamline daily school operations with a centralized platform for attendance, timetables, communication, fee management, examinations, and administrative workflows—all in one place.
    </p>
  </div>

  <div className="grid gap-10 items-center md:grid-cols-2 lg:gap-12">
    
    {/* Left Side: Dashboard Image (Ab image left mein aa gayi) */}
    <div className="relative">
      <div className="bg-white p-2 rounded-xl shadow-2xl border border-gray-100">
        <img
          src={mapimage}
          alt="School Management Dashboard"
          className="rounded-lg w-full h-auto"
        />
      </div>
    </div>

    {/* Right Side: Features (Ab features right mein aa gaye) */}
    <div className="grid grid-cols-1 gap-x-4 gap-y-5 sm:grid-cols-2 sm:gap-y-8">
      {Administration.map((feature, i) => (
        <div key={i} className="flex items-start gap-3">
          <div className="bg-orange-100 p-2 rounded-full text-orange-500 shrink-0">
            <RefreshCw size={18} />
          </div>
          <span className="text-sm font-semibold leading-snug text-gray-700 sm:text-base">{feature}</span>
        </div>
      ))}
    </div>

  </div>
</section>
  )
}

function Platform2() {
  return (
    <section className="mx-auto max-w-[1400px] px-4 py-12 sm:px-6 sm:py-16">
      <div className="grid gap-10 items-center md:grid-cols-2 lg:gap-12">

        {/* Left Side: Text and Features */}
        <div>
          <h2 className="mb-5 text-3xl font-bold leading-tight text-gray-900 sm:mb-6 sm:text-4xl">
            Driver Safety & Behavior Intelligence
          </h2>
          <p className="mb-8 text-base text-gray-600 sm:mb-10 sm:text-lg">
            Monitor driving patterns in real time to identify risky behavior, improve driver performance,
            reduce accidents, and ensure safer transportation for every student journey.
          </p>

          <div className="grid grid-cols-1 gap-x-4 gap-y-5 sm:grid-cols-2 sm:gap-y-6">
            {featureitem.map((featureitem, i) => (
              <div key={i} className="flex items-start gap-3">
                <div className="shrink-0 rounded-full bg-orange-100 p-2 text-orange-500">
                  <RefreshCw size={18} />
                </div>
                <span className="text-sm font-semibold leading-snug text-gray-700 sm:text-base">{featureitem}</span>
              </div>
            ))}
          </div>
        </div>

        {/* Right Side: Dashboard Image */}
        <div className="relative">
          <div className="bg-white p-2 rounded-xl shadow-2xl border border-gray-100">
            <img
              src={mapimage}
              alt="School Management Dashboard"
              className="rounded-lg w-full h-auto"
            />
          </div>
        </div>

      </div>
    </section>
  )
}

// function HowItWorksSection() {
//   return (
//     <section className="bg-white py-14 sm:py-16 lg:py-20">
//      <h2>hiii</h2>
//     </section>
//   )
// }

function TechnologySection() {
  return (
   <section className="mx-auto max-w-[1400px] px-4 py-12 sm:px-6 sm:py-16">
      {/* Heading Section */}
      <div className="mb-10 text-center sm:mb-16">
        <h2 className="mb-3 text-3xl font-bold text-gray-900 sm:text-4xl">Our Technology</h2>
        <p className="text-sm text-gray-600 sm:text-base">Fuel Automation That Goes Beyond Tracking</p>
      </div>

      {/* Content Section */}
      <div className="grid gap-10 items-center md:grid-cols-2 lg:gap-16">
        
        {/* Left Side: Features with Numbers */}
        <div>
          <h3 className="mb-7 text-sm font-medium text-gray-500 sm:mb-8 sm:text-base">Advanced hardware components</h3>
          <div className="space-y-7 sm:space-y-8">
            {items.map((text, i) => (
              <div key={i} className="group">
                <div className="flex items-start gap-4 sm:items-center sm:gap-6">
                  {/* Number styling */}
                  <span className="shrink-0 text-4xl font-bold text-orange-400 opacity-80 sm:text-5xl">
                    {String(i + 1).padStart(2, '0')}
                  </span>
                  <p className="text-base font-semibold leading-snug text-gray-800 sm:text-lg">{text}</p>
                </div>
                {/* Thin underline */}
                <div className="mt-4 h-[1px] w-full max-w-[300px] bg-gray-300"></div>
              </div>
            ))}
          </div>
        </div>

        {/* Right Side: Large Image */}
        <div className="relative">
          <img 
            src={slf} 
            alt="Fuel Automation" 
            className="h-[260px] w-full rounded-2xl object-cover shadow-xl sm:h-[360px] lg:h-[450px]"
          />
        </div>

      </div>
    </section>
  )
}

function BenefitsSection() {
  const [activeBenefit, setActiveBenefit] = useState(0)

  return (
    <section className="bg-white py-14 sm:py-16 lg:py-20">
      <Reveal>
        <div className="text-center">
          <h2 className="text-3xl font-bold tracking-[-0.04em] text-black sm:text-4xl lg:text-[42px]">
            Benefits
          </h2>

          <p className="mx-auto mt-4 max-w-[760px] px-4 text-sm leading-relaxed text-gray-600">
            We bring together GPS, fuel sensors, and telematics in one unified platform — built for seamless fleet automation and effective management.
          </p>
        </div>
      </Reveal>

      <div className="mt-8">
        {benefits.map((item, index) => {
          const isActive = activeBenefit === index

          return (
            <div
              key={item.title}
              onMouseEnter={() => setActiveBenefit(index)}
              onFocus={() => setActiveBenefit(index)}
              className={`group border-b border-black/25 transition-colors duration-500 ${isActive ? "bg-[#fff5ed]" : "bg-white hover:bg-[#fff5ed]"
                }`}
            >
              <Reveal>
                <div className="mx-auto grid max-w-[1060px] gap-7 px-4 py-10 sm:px-6 md:grid-cols-[170px_1fr] lg:grid-cols-[190px_1fr_360px] lg:py-12">
                  <div className="text-[62px] font-medium leading-none text-transparent [-webkit-text-stroke:1.3px_#ef7d00] sm:text-[80px] lg:text-[98px]">
                    {String(index + 1).padStart(2, "0")}
                  </div>

                  <div>
                    <div className="mb-4 flex h-11 w-11 items-center justify-center rounded-lg bg-[#ef7d00] text-white transition duration-300 group-hover:scale-110">
                      <RefreshIcon />
                    </div>

                    <h3 className="text-[24px] font-bold tracking-[-0.04em] text-black">
                      {item.title}
                    </h3>

                    <p className="mt-4 max-w-[430px] text-[15px] leading-relaxed text-gray-700">
                      {item.text}
                    </p>
                  </div>

                  <div
                    className={`hidden h-[140px] items-center justify-center overflow-hidden rounded-xl bg-white p-5 shadow-[0_8px_25px_rgba(0,0,0,0.12)] transition-all duration-500 ease-out lg:flex ${isActive
                      ? "translate-x-0 scale-100 opacity-100"
                      : "translate-x-8 scale-95 opacity-0"
                      }`}
                  >
                    <img
                      src={item.image}
                      alt={item.title}
                      className="h-full w-full rounded-lg object-cover transition duration-700 group-hover:scale-105"
                    />
                  </div>
                </div>
              </Reveal>
            </div>
          )
        })}
      </div>
    </section>
  )
}

function CtaSection() {
  return (
    <section className="bg-white py-14 sm:py-16 lg:py-20">
      <div className="mx-auto w-full max-w-[1600px] px-4 sm:px-6 lg:px-10 xl:px-14">
        <Reveal direction="zoom">
          <div className="w-full rounded-xl bg-gradient-to-r from-[#ef7d00] via-[#b66325] to-[#00176f] px-5 py-10 sm:px-14 sm:py-12 lg:px-20 lg:py-16">
            <h2 className="text-3xl font-bold text-black sm:text-4xl lg:text-[42px]">
              Get Started in Minutes
            </h2>

            <p className="mt-5 max-w-[820px] text-sm leading-relaxed text-black">
              Experience the power of automation with FleetRobo® AIS-140 ICAT Certified Devices
            </p>

            <div className="mt-8 flex flex-wrap gap-5">
              <a
                href="#contact"
                className="w-full rounded-md border border-white px-10 py-3.5 text-center text-[15px] font-medium text-white transition duration-300 hover:-translate-y-1 hover:bg-white hover:text-black sm:w-auto sm:px-12"
              >
                Contact us
              </a>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  )
}

// function ContactSection() {
//   return (
//     <section id="contact" className="bg-white py-14 sm:py-16 lg:py-20">
//       <div className={containerClass}>
//         <div className="grid gap-12 lg:grid-cols-[1fr_1.05fr]">
//           <Reveal direction="left">
//             <div>
//               <h2 className="text-3xl font-bold tracking-[-0.04em] text-black sm:text-4xl lg:text-[42px]">
//                 Get In Touch
//               </h2>

//               <p className="mt-5 text-sm leading-relaxed text-gray-600">
//                 Reach out to learn more about our smart waste management solution
//               </p>

//               <div className="relative mt-8 max-w-[520px]">
//                 <div className="h-[250px] overflow-hidden rounded-xl bg-gray-200 sm:h-[300px]">
//                   <img src={contactImg} alt="Contact desk" className="h-full w-full object-cover" />
//                 </div>

//                 <div className="absolute bottom-0 left-0 rounded-tr-xl bg-white px-3 py-2">
//                   <p className="mb-2 text-sm font-medium text-black">Follow us</p>

//                   <div className="flex gap-3">
//                     <a href="/" aria-label="Facebook" className="flex h-8 w-8 items-center justify-center rounded-md bg-[#0866ff] text-lg font-bold text-white">
//                       f
//                     </a>
//                     <a href="/" aria-label="Twitter" className="flex h-8 w-8 items-center justify-center rounded-full bg-[#1da1f2] text-lg font-bold text-white">
//                       t
//                     </a>
//                     <a href="/" aria-label="YouTube" className="flex h-8 w-10 items-center justify-center rounded-md bg-red-600 text-sm font-bold text-white">
//                       ▶
//                     </a>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </Reveal>

//           <Reveal direction="right">
//             <form className="grid gap-5">
//               <div className="grid gap-5 sm:grid-cols-2">
//                 <label className="text-sm font-semibold text-black">
//                   Full Name*
//                   <input className="mt-2 h-12 w-full rounded-lg bg-[#e7e7e7] px-4 outline-none transition focus:ring-2 focus:ring-[#ef7d00]" />
//                 </label>

//                 <label className="text-sm font-semibold text-black">
//                   Organization*
//                   <input className="mt-2 h-12 w-full rounded-lg bg-[#e7e7e7] px-4 outline-none transition focus:ring-2 focus:ring-[#ef7d00]" />
//                 </label>
//               </div>

//               <div className="grid gap-5 sm:grid-cols-2">
//                 <label className="text-sm font-semibold text-black">
//                   Email Address*
//                   <input className="mt-2 h-12 w-full rounded-lg bg-[#e7e7e7] px-4 outline-none transition focus:ring-2 focus:ring-[#ef7d00]" />
//                 </label>

//                 <label className="text-sm font-semibold text-black">
//                   Phone Number*
//                   <input className="mt-2 h-12 w-full rounded-lg bg-[#e7e7e7] px-4 outline-none transition focus:ring-2 focus:ring-[#ef7d00]" />
//                 </label>
//               </div>

//               <label className="text-sm font-semibold text-black">
//                 Subject
//                 <input className="mt-2 h-12 w-full rounded-lg bg-[#e7e7e7] px-4 outline-none transition focus:ring-2 focus:ring-[#ef7d00]" />
//               </label>

//               <label className="text-sm font-semibold text-black">
//                 Message*
//                 <textarea className="mt-2 h-[116px] w-full resize-none rounded-lg bg-[#e7e7e7] px-4 py-3 outline-none transition focus:ring-2 focus:ring-[#ef7d00]" />
//               </label>

//               <button
//                 type="button"
//                 className="mt-2 h-14 rounded-lg bg-[#ef7d00] text-[15px] font-medium text-white transition duration-300 hover:-translate-y-1 hover:bg-[#d96f00]"
//               >
//                 Send message
//               </button>
//             </form>
//           </Reveal>
//         </div>
//       </div>
//     </section>
//   )
// }

export default function Section6() {
  return (
    <>
      <div className="bg-white font-['Poppins'] text-black">
        <HeroSection />
        <div id="why-choose-solution">
          <KeyFeatures features={features} />
        </div>

        <Platform />
        <Administrations />
        <Platform2 />
        <SchoolBusTracking/>
        <HowItWorksSection />
        <TechnologySection />
        <BenefitsSection />
        <CtaSection />
        {/* <ContactSection /> */}
      </div>
      <Footer />
    </>
  )
}